/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PersonalDocumentStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  VALIDATION_PENDING = 'VALIDATION_PENDING',
}
